import React, { useEffect, useState } from 'react';
import './style/PaymentSuccess.css';
import TopNavbar from '../home/TopNavbar';
import { Link } from 'react-router-dom';

const PaymentSuccess = ({ orderDetails }) => {
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);



  return (
    <div className="payment-success-container">


      <div className="success-card">
        <div className={`checkmark-container ${isAnimating ? 'animating' : ''}`}>
          <svg
            className="checkmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              className="checkmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="checkmark__check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <div className="success-content">
          <h1 className="success-title">Payment Successful!</h1> <br></br>
          <p className="success-message">
            Thank you for your purchase. Your payment has been processed successfully.
          </p>
        </div>



        <div className="additional-info">
          <p className="info-text">
            Now you can access all features in our app. Now go to  home page and access premium content.
          </p>
          <br></br>
          <div className="support-info">
            <Link to="https://neetmocktest.mystudyplace.in/" className="support-link">Open app </Link>
          </div>
        </div>
        <br></br>
      

      </div>
    </div>
  );
};

export default PaymentSuccess;